// import React, { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useAuth } from '../contexts/authContext';
// import { API_URL } from '../lib/config';
// import './SettingsPage.css'; // ★ CSS 파일 import 확인!

// function MyInfoPage() {
//     const { currentUser } = useAuth();
//     const navigate = useNavigate();
//     const [userInfo, setUserInfo] = useState(null);
//     const [loading, setLoading] = useState(true);

//     useEffect(() => {
//         if (!currentUser) return;
        
//         const fetchUserInfo = async () => {
//             try {
//                 const idToken = await currentUser.getIdToken();
//                 const response = await fetch(`${API_URL}/api/login/me`, {
//                     headers: { 'Authorization': `Bearer ${idToken}` }
//                 });
//                 const data = await response.json();
//                 if (response.ok) setUserInfo(data.user);
//             } catch (error) {
//                 console.error("정보 로딩 실패", error);
//             } finally {
//                 setLoading(false);
//             }
//         };
//         fetchUserInfo();
//     }, [currentUser]);

//     const formatDate = (dateString) => {
//         if (!dateString) return '정보 없음';
//         const date = new Date(dateString);
//         return date.toISOString().split('T')[0];
//     };

//     const formatGender = (gender) => {
//         if (gender === 'male') return '남성';
//         if (gender === 'female') return '여성';
//         return '기타';
//     };

//     if (loading) return <div className="settings-page-container" style={{padding: '100px'}}>로딩 중...</div>;

//     return (
//         <div className="settings-page-container">
//             {/* ★ 배경 별 애니메이션 추가 (CSS가 이걸 기준으로 디자인됨) */}
//             <div id="bright-stars1"></div>
//             <div id="bright-stars2"></div>
//             <div id="bright-stars3"></div>

//             {/* 상단 바 (클래스명 수정: settings-header -> settings-top-bar) */}
//             <div className="settings-top-bar">
//                 <button className="back-button-icon" onClick={() => navigate(-1)}>
//                     ←
//                 </button>
//                 <div className="top-bar-title">내 정보</div>
//             </div>

//             {/* 메인 콘텐츠 (클래스명 수정: settings-content -> settings-main-content) */}
//             <main className="settings-main-content">
//                 {/* 여기는 메뉴 리스트가 아니라 정보 카드이므로 
//                     settings-menu-item 대신 별도의 스타일을 줘도 되지만,
//                     통일감을 위해 settings-menu-item 스타일을 응용해서 보여줍니다.
//                 */}
//                 <div className="settings-menu-list">
//                     <div className="settings-menu-item" style={{ cursor: 'default', flexDirection: 'column', alignItems: 'flex-start', gap: '10px' }}>
//                         <span className="menu-label" style={{color: '#888', fontSize: '0.9em'}}>이메일</span>
//                         <span style={{fontWeight: 'bold'}}>{userInfo?.email || '게스트 로그인'}</span>
//                     </div>

//                     <div className="settings-menu-item" style={{ cursor: 'default', flexDirection: 'column', alignItems: 'flex-start', gap: '10px' }}>
//                         <span className="menu-label" style={{color: '#888', fontSize: '0.9em'}}>생년월일</span>
//                         <span style={{fontWeight: 'bold'}}>{formatDate(userInfo?.birthday)}</span>
//                     </div>

//                     <div className="settings-menu-item" style={{ cursor: 'default', flexDirection: 'column', alignItems: 'flex-start', gap: '10px' }}>
//                         <span className="menu-label" style={{color: '#888', fontSize: '0.9em'}}>성별</span>
//                         <span style={{fontWeight: 'bold'}}>{formatGender(userInfo?.gender)}</span>
//                     </div>

//                     <p style={{ fontSize: '12px', color: '#666', marginTop: '10px', textAlign: 'center', width: '100%' }}>
//                         * 생년월일 및 성별은 가입 후 변경할 수 없습니다.
//                     </p>
//                 </div>
//             </main>
//         </div>
//     );
// }

// export default MyInfoPage;

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/authContext';
import { API_URL } from '../lib/config';
import './SettingsPage.css'; 

function MyInfoPage() {
    const { currentUser } = useAuth();
    const navigate = useNavigate();
    const [userInfo, setUserInfo] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isUpdating, setIsUpdating] = useState(false); // 업데이트 로딩 상태

    useEffect(() => {
        if (!currentUser) return;
        
        const fetchUserInfo = async () => {
            try {
                const idToken = await currentUser.getIdToken();
                // 백엔드 /api/login/me 에서 subscriptionStatus, currentPeriodEnd, preferredGender를 꼭 보내줘야 합니다!
                const response = await fetch(`${API_URL}/api/login/me`, {
                    headers: { 'Authorization': `Bearer ${idToken}` }
                });
                const data = await response.json();
                if (response.ok) setUserInfo(data.user);
            } catch (error) {
                console.error("정보 로딩 실패", error);
            } finally {
                setLoading(false);
            }
        };
        fetchUserInfo();
    }, [currentUser]);

    const formatDate = (dateString) => {
        if (!dateString) return '정보 없음';
        const date = new Date(dateString);
        return date.toISOString().split('T')[0];
    };

    const formatGender = (gender) => {
        if (gender === 'male') return '남성';
        if (gender === 'female') return '여성';
        return '기타';
    };

    const now = new Date();
    
    // ⭐ PLUS 유저인지 판별하는 로직
    const isPlus = (userInfo?.subscriptionStatus === 'active' || userInfo?.subscriptionStatus === 'canceled') 
               && new Date(userInfo?.currentPeriodEnd) > now;

    // ⭐ 선호 성별 변경 API 호출 함수
    const handlePreferredGenderChange = async (e) => {
        const newPreferred = e.target.value;
        if (!isPlus) return; // 혹시 모를 꼼수 방지

        setIsUpdating(true);
        try {
            const idToken = await currentUser.getIdToken();
            // 이 API 라우터는 백엔드에 새로 만들어줘야 합니다!
            const response = await fetch(`${API_URL}/api/login/preferences`, {
                method: 'PUT',
                headers: { 
                    'Authorization': `Bearer ${idToken}`,
                    'Content-Type': 'application/json' 
                },
                body: JSON.stringify({ preferredGender: newPreferred })
            });

            if (response.ok) {
                setUserInfo({ ...userInfo, preferredGender: newPreferred });
            } else {
                alert('설정 저장에 실패했습니다.');
            }
        } catch (error) {
            console.error("업데이트 에러", error);
        } finally {
            setIsUpdating(false);
        }
    };

    if (loading) return <div className="settings-page-container" style={{padding: '100px'}}>로딩 중...</div>;

    return (
        <div className="settings-page-container">
            <div id="bright-stars1"></div>
            <div id="bright-stars2"></div>
            <div id="bright-stars3"></div>

            <div className="settings-top-bar">
                <button className="back-button-icon" onClick={() => navigate(-1)}>←</button>
                <div className="top-bar-title">내 정보</div>
            </div>

            <main className="settings-main-content">
                <div className="settings-menu-list">
                    {/* 기존 정보들 */}
                    <div className="settings-menu-item" style={{ cursor: 'default', flexDirection: 'column', alignItems: 'flex-start', gap: '10px' }}>
                        <span className="menu-label" style={{color: '#888', fontSize: '0.9em'}}>이메일</span>
                        <span style={{fontWeight: 'bold'}}>{userInfo?.email || '게스트 로그인'}</span>
                    </div>

                    <div className="settings-menu-item" style={{ cursor: 'default', flexDirection: 'column', alignItems: 'flex-start', gap: '10px' }}>
                        <span className="menu-label" style={{color: '#888', fontSize: '0.9em'}}>생년월일</span>
                        <span style={{fontWeight: 'bold'}}>{formatDate(userInfo?.birthday)}</span>
                    </div>

                    <div className="settings-menu-item" style={{ cursor: 'default', flexDirection: 'column', alignItems: 'flex-start', gap: '10px' }}>
                        <span className="menu-label" style={{color: '#888', fontSize: '0.9em'}}>내 성별</span>
                        <span style={{fontWeight: 'bold'}}>{formatGender(userInfo?.gender)}</span>
                    </div>

                    <div style={{ height: '1px', backgroundColor: 'rgba(255,255,255,0.1)', margin: '10px 0' }}></div>

                    {/* ⭐ 새로 추가된 '원하는 매칭 성별' 구역 ⭐ */}
                    <div className="settings-menu-item" style={{ cursor: 'default', flexDirection: 'column', alignItems: 'flex-start', gap: '10px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
                            <span className="menu-label" style={{color: isPlus ? '#FFD700' : '#888', fontSize: '0.9em', fontWeight: isPlus ? 'bold' : 'normal'}}>
                                원하는 매칭 상대 성별 {isPlus && '✨'}
                            </span>
                            
                            <select 
                                value={userInfo?.preferredGender || 'any'}
                                onChange={handlePreferredGenderChange}
                                disabled={!isPlus || isUpdating}
                                style={{
                                    padding: '5px 10px',
                                    borderRadius: '5px',
                                    backgroundColor: isPlus ? '#222' : '#111',
                                    color: isPlus ? '#FFF' : '#555',
                                    border: isPlus ? '1px solid #FFD700' : '1px solid #333',
                                    outline: 'none',
                                    cursor: isPlus ? 'pointer' : 'not-allowed'
                                }}
                            >
                                <option value="any">상관없음 (전체)</option>
                                <option value="female">여성만</option>
                                <option value="male">남성만</option>
                            </select>
                        </div>
                        
                        {/* PLUS 유저가 아닐 때 보여줄 안내 문구 */}
                        {!isPlus && (
                            <div 
                                style={{ width: '100%', fontSize: '12px', color: '#AAA', marginTop: '5px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                            >
                                <span>TAIM PLUS 전용 프리미엄 기능입니다.</span>
                                <button 
                                    onClick={() => navigate('/subscription')}
                                    style={{ background: 'none', border: 'none', color: '#FFD700', textDecoration: 'underline', cursor: 'pointer', fontSize: '12px', padding: 0 }}
                                >
                                    알아보기
                                </button>
                            </div>
                        )}
                    </div>

                    <p style={{ fontSize: '12px', color: '#666', marginTop: '10px', textAlign: 'center', width: '100%' }}>
                        * 생년월일 및 내 성별은 가입 후 변경할 수 없습니다.
                    </p>
                </div>
            </main>
        </div>
    );
}

export default MyInfoPage;